// import Link from 'next/link'
// import styled from '@emotion/styled'
import Image from 'next/image'
import {useRouter} from 'next/router'
import React, {useEffect, useRef, useState} from 'react'
import SidebarNavMobile from './SidebarNavMobile'
import SidebarNavDesktop from './SidebarNavDesktop'
import {MenuIcon} from '@heroicons/react/outline'
import tw from 'twin.macro'
import MainHeader from './MainHeader'
import OrderHeader from './OrderHeader'
import Link from 'next/link'
import OrderStatus from './OrderStatus'
import CalendarIcon from '../public/calendar.png'
import FileIcon from '../public/file-icon.png'
import HomeIcon from '../public/home-icon.png'
import HomeDisIcon from '../public/home-icon-disable.png'
import ItemListIcon from '../public/item-list.png'
import ItemListDisIcon from '../public/item-list-disabled.png'
import ReplacementIcon from '../public/replacement-item.png'
import ReplacementDisIcon from '../public/replacement-item-disabled.png'
import OrderIcon from '../public/order-icon.png'
import OrderDisIcon from '../public/order-icon-disabled.png'
import OrderDetails from '../pages/order/[id]/order-details'
import UpdateItems from '../pages/order/[id]/update-items'
import UpdateProof from '../pages/order/[id]/update-proof'
import UpdateAddress from '../pages/order/[id]/update-address'
import Reorder from '../pages/order/[id]/reorder'
import Refund from '../pages/order/[id]/refund'
import {useSessionStorageState} from '../utils/useSessionStorageState'
import {isCancelOrderDisabled, isEmailedFolder} from '../utils/folders'
import {isTiktokHost} from '../utils/tiktokOrderDisplay'
import {initialState, lookupStorageKey} from '../apollo/cache'
import CancelOrder from '../pages/order/[id]/cancel-order'
import CloseIcon from '../public/close-icon.png'
import {Modal} from 'reactstrap'
import Loader from '../components/Loader'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  faCalendarCheck,
  faList,
  faFileLines,
  faHouseChimney,
  faRightLeft,
  faCartShopping,
  faXmark,
  faTrashCan,
  faEye,
} from '@fortawesome/free-solid-svg-icons'
import useDeliveryStatus from '../hooks/useDeliveryStatus'
import useLostInTransit from '../hooks/useLostInTransit';
import {isMobile} from 'react-device-detect'
import {FirebaseClient} from '../apollo/FirebaseClient'
import {useLazyQuery} from '@apollo/client'
import {OrderByIdQuery, RefundRequestQuery, OrderQuery, OrdersByEmailQuery} from '../apollo/queries'
import GenericSidebar from '../components/GenericSidebar';
import BannerWithTooltip from './ui/BannerWithTooltip'
import useSessionTimeout from '../hooks/useSessionTimeout';
import SessionTimeoutSidebar from './SessionTimeoutSidebar';

declare let $: any

const SiteLayout = ({children}) => {
  const [shQuantity, setShQuantity] = useState(false)
  const [modalCancel, setModalCancel] = useState(false)
  const toggleShow = () => setModalCancel(p => !p)
  const [isToggled, setToggle] = useState(false)
  const [itemValue, setItemValue] = useState('Item')
  const [match, setmatch] = useState(false)
  const [isTiktok, setIsTiktok] = useState(false)
  const toggleItem = () => {
    setToggle(!isToggled)
    isToggled
      ? setItemValue('Items')
      : setItemValue('Edit Items')
  }
  const [addressValue, setAddressValue] = useState(
    'Shipping Address',
  )
  const [delStatus, setdelStatus] = useState({
    attempt: '',
    status: '',
    last_detail: {datetime: ''},
  })
  const [refundStatus, setrefundStatus] = useState(false)
  const [cancelSidebarOpen, setCancelSidebarOpen] = useState(false);
  const [sessionTimeoutSidebarOpen, setSessionTimeoutSidebarOpen] = useState(false);
  setTimeout(function () {}, 2000)

  const toggleAddress = () => {
    setToggle(!isToggled)
    isToggled
      ? setAddressValue('Shipping Address')
      : setAddressValue('Edit Address')
  }
  const [isProofsToggled, setProofsToggle] = useState(false)
  const toggleProofs = () => {
    setProofsToggle(!isProofsToggled)
  }
  
  const [success, setSuccess] = useState(null)
  const editItemsTooltipRef = useRef(null);
  const editAddressTooltipRef = useRef(null);
  const reviewProofsTooltipRef = useRef(null);
  const replaceReturnTooltipRef = useRef(null);  
  const [isMounted, setIsMounted] = useState(false);

  // Session timeout hook
  const { isTimedOut, resetTimeout, clearSessionTimeout } = useSessionTimeout({
    timeoutMs: 300000, // 5 minutes
    onTimeout: () => {
      setSessionTimeoutSidebarOpen(true);
    },
  });

  //toggle button value
  const router = useRouter()
  const {query} = router
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [state, setStorageState] = useSessionStorageState(
    lookupStorageKey,
    initialState,
  )

  const {order} = state

  const {checkDeliveryStatus, status} = useDeliveryStatus(
    order.id,
  )

  const convertDate = value => {
    const dateConvo = new Date(
      value?.toString().replace(/ /g, 'T'),
    )

    let d: string | number = dateConvo.getDate()
    let m: string | number = dateConvo.getMonth() + 1
    let y = dateConvo.getFullYear()

    if (m.toString().length === 1) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      m = '0' + m.toString()
    }
    if (d.toString().length === 1) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      d = '0' + d.toString()
    }

    // setting up date format - mm/dd/yy 2022-7-28
    const finalDate = y.toString() + '-' + m + '-' + d
    // console.log(finalDate.replace(/ /g, 'T'),"finalDate")
    return finalDate
  }

  const orderMeta = state.order.order_metadata
  const emailedFor = orderMeta?.find(
    v => v.key === 'Emailed For',
  )?.value
  // console.log(emailedFor, 'emailedFor')
  const OrderItems = state.order.order_items

  //delievery status
  // const [delivery_status, setdelivery_status] = useState(
  //   state?.order?.order_metadata?.find(
  //     v => v.key === 'delivery_status',
  //   )?.value,
  // )
  // const [diffDaysForDelivery, setdiffDaysForDelivery] =
  //   useState(0)
  // console.log('diffDaysForDelivery', diffDaysForDelivery)
  // console.log('UE Delivery STatus: ', delivery_status)

  // useEffect(() => {
  //   if (typeof delivery_status === 'string') {
  //     console.log('UE Delivery STatus: 22', delivery_status)
  //     setdelivery_status(JSON.parse(delivery_status))
  //     console.log('UE Delivery STatus: ', delivery_status)
  //   }
  //   return null
  // }, [delivery_status])

  // useEffect(() => {
  //   if (delivery_status?.attempt !== null) {
  //     const date11 = new Date(delivery_status?.attempt)
  //     const date22 = new Date()
  //     const diffTime = Math.abs(+date22 - +date11)
  //     setdiffDaysForDelivery(
  //       Math.ceil(diffTime / (1000 * 60 * 60 * 24)),
  //     )
  //     console.log(delivery_status?.attempt, 'date11')
  //     console.log(date11, 'date11')
  //     console.log(diffTime, 'diffTime')
  //   }
  //   return null
  // }, [delivery_status])

  //window width
  const [activeMenu, setActiveMenu] = useState(false)
  const [screenSize, setScreenSize] = useState(undefined)
  const [loads, setLoads] = useState(true)

  const [windowWidth, setWindowWidth] = useState(1024)
  const [windowHeight, setWindowHeight] = useState(1024)
  const [requestBanner, setRequestBanner] = useState(null);
  
  //check if its a replacement order or not
  const replacementSuffix = [
    'DS',
    'DS',
    'LIT',
    'DIT',
    'RP',
    'RP',
    'LIT',
  ]

  const isLostInTransit = useLostInTransit();
  const [newOrderID, setNewOrderID] = useState(null);
  const pendingOrderIdRef = useRef(null);
  const currentOrderID = router.query.orderID || state.orderNumber;
  const ordersList = state?.ordersList || [];
  const sidebarRef = useRef<HTMLDivElement | null>(null);
  // let str
  // str = state?.orderNumber

  // useEffect(() => {
  //   if (replacementSuffix.some(v => str.includes(v))) {
  //     setmatch(true)
  //   } else {
  //     // console.log(`No match using "${str}"`)
  //   }
  // }, [str, ])
  const createCardClickHandler = (
    collapseId: string,
    tooltipRef?: React.MutableRefObject<(() => void) | null>
  ) => (e: React.MouseEvent<HTMLElement>) => {
    const card = e.currentTarget as HTMLElement;
  
    if (card.classList.contains('disabled')) {
      e.stopPropagation();
      if (tooltipRef?.current) {
        tooltipRef.current();
      }
      return;
    }
  
    const target = e.target as Element;
    const isCardHeader = target.closest('.card-header');
    const isCardBody = target.closest('.card-body');
  
    if (isCardHeader && !isCardBody) {
      const section = card.querySelector(`#${collapseId}`);
      if (section) {
        const isShown = section.classList.contains('show');
        if (typeof window !== 'undefined') {
          $(section).collapse(isShown ? 'hide' : 'show');
        }
      }
    }
  };
  

  useEffect(() => {
    setIsMounted(true);
    setIsTiktok(isTiktokHost());

    if (typeof window === 'undefined') return;

    const handleResize = () => {
      if (window.innerWidth > 990 && sidebarRef.current) {
        let fixedHeight = sidebarRef.current.offsetHeight;
        if( fixedHeight < 590) {
          fixedHeight = 590;
        }
        sidebarRef.current.style.height = `${fixedHeight}px`;
      }
    };
  
    // Delay to allow DOM/layout to complete rendering
    const timeout = setTimeout(() => {
      handleResize();
    }, 100); // adjust as needed
  
    window.addEventListener('resize', handleResize);

    setTimeout(() => {
      setLoads(false)
    }, 3000)

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', handleResize);
    };
  }, [])


  useEffect(() => {
    var hours = 24
    var now = Date.now()

    // else if(now - state.timestamp > hours * 60 * 60 * 1000) {
    //   localStorage.removeItem('dangle-it-crm:lookup-state')
    //   window.location.href = '/'
    // }

    if (state.authenticated && state.orderNumber && !newOrderID) {
      const currentOrderId = router.query.id
      if (currentOrderId && currentOrderId != state.orderNumber) {
        router.replace(`/order/${state.orderNumber}`)
      }
    }

    const handleResize = () => {
      if (typeof window !== 'undefined') {
        setScreenSize(window.innerWidth)
      }
    }
    window.addEventListener('resize', handleResize)
    handleResize()

    return () =>
      window.removeEventListener('resize', handleResize)
  }, [state, delStatus])

  useEffect(() => {
    if (!state.authenticated) {
      localStorage.removeItem('dangle-it-crm:lookup-state');
      window.location.replace('/');
    }
  }, [state.authenticated]);  

  useEffect(() => {
    if (screenSize <= 992) setActiveMenu(true)
    else setActiveMenu(false)

    if (typeof window !== 'undefined') {
    setWindowWidth(window.innerWidth)
    setWindowHeight(window.innerHeight)
    }
  }, [screenSize])

  const [fetchOrder, {loading, networkStatus}] = useLazyQuery(
    RefundRequestQuery,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      ssr: false,
      onCompleted(data) {
        // console.log('order retrieved site layout test', data)

        let {getRefundRequest: refundData} = data;

        // console.log('refundData', {refundData, test: refundData?.[0]})

        if(refundData?.[0]?.status === 'Rejected') {
          console.log('Rejected')
          setrefundStatus(false);
        }
        else if(['Approved', 'Pending'].includes(refundData?.[0]?.status)) {
          console.log('Approved')
          setrefundStatus(true);
        }
      },
      onError(error) {
        console.log('Error? ', error)
      },
    },
  )
  // Fetch new order data when order ID changes in the URL
  const [fetchNewOrder] = useLazyQuery(OrderQuery, {
    fetchPolicy: 'network-only',
    onCompleted(data) {
      if (data?.getOrder) {
        const selectedId = pendingOrderIdRef.current
        setStorageState((prev) => {
          const nextState = {
            ...prev,
            order: data.getOrder,
            orderNumber: selectedId,
          }
          window.localStorage.setItem(
            lookupStorageKey,
            JSON.stringify(nextState),
          )
          return nextState
        })
        window.location.assign(`/order/${selectedId}`)
      }
    },
  });
  const [fetchOrdersByEmail] = useLazyQuery(OrdersByEmailQuery, {
    fetchPolicy: 'network-only',
    onCompleted(data) {
      setStorageState((prev) => ({
        ...prev,
        ordersList: data.getOrdersByEmail, // Store all orders in state
      }));
    },
  });

  // Handle order selection change
  const handleOrderChange = (event) => {
    const newOrderId = event.target.value;

    pendingOrderIdRef.current = newOrderId
    setNewOrderID(newOrderId);
    fetchNewOrder({ variables: { id: newOrderId, email: state.email } });
  };

  useEffect(() => {
    // Only fetch orders list if:
    // - We are authenticated
    // - We have a valid email
    // - And we either never fetched ordersList or it’s empty
    if (
      state.authenticated &&
      state.email &&
      (!state.ordersList || state.ordersList.length === 0)
    ) {
      fetchOrdersByEmail({ variables: { email: state.email } });
    }
  }, [state.authenticated, state.email, state.ordersList?.length]);
  

  useEffect(() => {
    setRequestBanner(getRequestBanner()); // Recalculate the banner when refundStatus updates
  }, [refundStatus, order, delStatus]);  

  useEffect(() => {
    if (!state.ordersList || state.ordersList.length === 0) {
      if (state.email) {
        fetchOrdersByEmail({ variables: { email: state.email } });
      }
    }
  }, [state.ordersList, state.email]);  

  var flagVal = ''
  var scentVal
  if (OrderItems?.length > 0) {
    OrderItems?.forEach(item => {
      item.variation_list?.forEach(itemVariation => {
        if (itemVariation.key == 'Flag') {
          // flagVal += itemVariation.value
          flagVal = itemVariation.value
        }
      })
    })
  }
  if (flagVal !== 'undefined') {
    flagVal = flagVal
  } else {
    flagVal = ''
  }

  const order_shipments = state.order.order_shipments
  const date_shipped = order_shipments?.find(
    v => v.date_added, // .date_shipped replaced with this
  )?.date_added // .date_shipped replaced with this
  // console.log(date_shipped,"date_shipped234")

  let shippedDate = new Date(date_shipped)
  let endDate = shippedDate.setDate(shippedDate.getDate() + 10)
  let Enddate = new Date(endDate).toLocaleDateString('fr-CA')

  const date1 = new Date(date_shipped)
  const date2 = new Date()
  const diffTime = Math.abs(+date2 - +date1)
  var diffDaysForShipping = Math.floor(
    diffTime / (1000 * 60 * 60 * 24),
  )

  let delivery_status = state?.order?.order_metadata?.find(
    v => v.key === 'delivery_status',
  )?.value

  //get REPLACMENT REQUEST response from OD
  const extended = order?.order_metadata?.find(
    v => v.key === 'ExtendRequestUntil',
  )?.value
  const isReturnable =
    new Date(extended?.replaceAll('-', '/')).getTime() -
    new Date().getTime()

  //get refund response from OD
  const refundResponse = order?.order_metadata?.find(
    v => v.key === 'Partially Refunding',
  )?.value
  const fullyRefundResponse = order?.order_metadata?.find(
    v => v.key === 'Fully Refunding',
  )?.value
  const statusBanner = order?.order_metadata?.find(
    v => v.key === 'order_status_banner_text',
  )?.value
  const shopifyCancel = order?.order_metadata?.find(
    v => v.key === 'shopify_cancelled_at',
  )?.value
  const cancelOrder = order?.order_metadata?.find(
    v => v.key === 'Cancel',
  )?.value
  const cancelOrderDate = order?.order_metadata?.find(
    v => v.key === 'order_canceled_on',
  )?.value

  const index = order?.orderNumber?.includes(replacementSuffix)

  //logout
  const logoutUser = () => {
    localStorage.removeItem('dangle-it-crm:lookup-state')
    window.location.href = '/'
  }

  const dateChange = delStatus?.last_detail?.datetime
  // console.log(dateChange, 'dateChange')

  const date123 = new Date(dateChange)
  const date234 = new Date()
  const diffTimes = Math.abs(+date234 - +date123)
  var diffDaysForTracking = Math.floor(
    diffTimes / (1000 * 60 * 60 * 24),
  )

  if (delStatus?.status == 'delivered') {
    const date11 = new Date(dateChange)
    const date22 = new Date()
    const diffTime = Math.abs(+date22 - +date11)
    var diffDaysForDelivery = Math.floor(
      diffTime / (1000 * 60 * 60 * 24),
    )
  }
  const collapseSection = target => {
    if (windowWidth <= 992 && isMobile) {
      if (target == 'sidebar-collapse') {
        $('div#accordion div.card div.collapse.show').collapse(
          'hide',
        )
      } else {
        $('div#sidebar-collapse').collapse('hide')
      }
    }
  }

  const orderRefundRequest = order?.order_metadata?.find(v => v.key === 'request_status')?.value?.toLowerCase();
  const isRequestProcessed = orderRefundRequest === "pending" || orderRefundRequest === "approved";

  // Function to Determine Request Banner Text & Color
  const getRequestBanner = () => {
    const requestStatus = order?.order_metadata?.find(v => v.key === 'request_status')?.value;
    const refundAmount = order?.order_metadata?.find(v => v.key === 'Refund Amount')?.value;
    const replacementOrderId = order?.order_metadata?.find(v => v.key === 'replacement_order_source_id')?.value;

    if (isLostInTransit && requestStatus != "Pending" && !refundStatus){
      return null
    }
    if (requestStatus === "Pending" || refundStatus == true) {
      return { text: "Request Pending", color: 'colorYellow' };
    }
    if (replacementOrderId) {
      return {
        text: "Approved",
        tooltip: `Approved`,
        color: "colorGreen",
        reference: replaceReturnTooltipRef
      };
    }
    if (requestStatus === "Rejected") {
      return {
        text: "Rejected",
        tooltip: "See email for rejection reason",
        color: "colorRed",
        reference: replaceReturnTooltipRef,
        collapseId: "collapseFour"
      };
    }
    if (requestStatus === "Cancelled") {
      return {
        text: "Cancelled",
        tooltip: "Cancelled",
        color: "colorRed"
      };
    }
    if (requestStatus === "Approved" && refundAmount) {
      return {
        text: "Approved",
        tooltip: `Approved`,
        color: "colorGreen"
      };
    }
  
    // Unavailable cases
    if ([435757, 435734, 435735].includes(order.folder_id)) {
      return {
        text: "Unavailable",
        tooltip: "Not yet shipped",
        color: "colorGray",
        reference: replaceReturnTooltipRef
      };
    }
    if (order_shipments?.length === 0) {
      return {
        text: "Unavailable",
        tooltip: "Not yet shipped",
        color: "colorGray",
        reference: replaceReturnTooltipRef
      };
    }
    if (delStatus?.status !== 'delivered' && diffDaysForTracking <= 5) {
      return {
        text: "Unavailable",
        tooltip: "Tracking updated < 5 days ago",
        color: "colorGray",
        reference: replaceReturnTooltipRef
      };
    }
    if (delStatus?.status === 'delivered' && diffDaysForDelivery > 7) {
      return {
        text: "Unavailable",
        tooltip: "Delivered > 7 days ago",
        color: "colorGray",
        reference: replaceReturnTooltipRef
      };
    }
  
    return null;
  };
  
  if (!isMounted) return null;
  // console.log(order.folder_id, delStatus?.status, refundStatus, diffDaysForDelivery, diffDaysForTracking, isLostInTransit)
  // console.log('test')

  // console.log('diffDaysForDelivery', diffDaysForDelivery)
  // console.log('diffDaysForTracking', diffDaysForTracking)
  // console.log('diffDaysForShipping', diffDaysForShipping)
  // console.log('order', order)
  // console.log('delStatus', delStatus)
  // console.log('refundStatus', refundStatus)
  // console.log('extended', new Date(extended).getTime())
  // console.log(new Date().getTime())
  // console.log(new Date(extended).getTime() > new Date().getTime())

  return (
    state.authenticated && (
      <div className="custom_site_layout customBgColor">
        {loads && (
          <div className="loader-box">
            <Loader />
          </div>
        )}
        <div className="top-header-box ">
          <MainHeader orderID={query?.id} order={order} handleOrderChange={handleOrderChange} ordersList={ordersList} isTiktok={isTiktok}/>
          <OrderHeader orderID={query?.id} order={order} handleOrderChange={handleOrderChange} ordersList={ordersList} isTiktok={isTiktok} />
        </div>
        <div className="pb-5 ">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div id="acc-sidebar" className="accordian-box" ref={sidebarRef} >
                  <div className="card">
                    <div
                      className="card-header"
                      id="sidebar-heading"
                      tw="cursor-pointer"
                      onClick={() => {
                        const sidebar = document.getElementById('sidebar-collapse');
                        if (sidebar) {
                          const isShown = sidebar.classList.contains('show');
                          $(sidebar).collapse(isShown ? 'hide' : 'show');
                        }
                      }}
                    >
                      {/* {success === 'success' &&
                      !cancelOrder &&
                      !shopifyCancel ? (
                        <div className="banner-text sidebar-banner ">
                          Order Canceled via Order Portal{' '}
                          {new Date(
                            convertDate(order?.date_added),
                          ).toLocaleDateString('en-US', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          })}
                        </div>
                      ) : cancelOrder && !cancelOrderDate ? (
                        <div className="banner-text sidebar-banner ">
                          Order Canceled via Order Portal
                        </div>
                      ) : cancelOrder ? (
                        <div className="banner-text sidebar-banner ">
                          Order Canceled via Order Portal on{' '}
                          {new Date(
                            cancelOrderDate?.replaceAll(
                              '-',
                              '/',
                            ),
                          ).toLocaleDateString('en-US', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          })}
                        </div>
                      ) : shopifyCancel ? (
                        <div className="banner-text sidebar-banner ">
                          Order Canceled by Admin on{' '}
                          {new Date(
                            convertDate(shopifyCancel),
                          ).toLocaleDateString('en-US', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                          })}
                        </div>
                      ) : statusBanner ? (
                        <div className="banner-text sidebar-banner yellow-banner">
                          {statusBanner}
                        </div>
                      ) : (
                        ''
                      )} */}
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          aria-expanded="true"
                          aria-controls="sidebar-collapse"
                        >
                          <span className="cal-logo">
                            {/* <Image
                              className="file-icon-img"
                              alt=""
                              src={CalendarIcon}
                            /> */}
                            <FontAwesomeIcon
                              icon={faCalendarCheck}
                            />
                          </span>
                          <span className="tab-text">
                            Order Status
                          </span>
                        </button>
                      </h5>
                    </div>

                    <div
                      id="sidebar-collapse"
                      className={`${
                        activeMenu
                          ? 'collapse '
                          : 'collapse show'
                      }`}
                      // className="collapse show"
                      aria-labelledby="sidebar-heading"
                      data-parent="#acc-sidebar"
                    >
                      <div className="card-body">
                        <div className="card-body-inner">
                          <OrderStatus
                            success={success}
                            state={state}
                            setdelStatus={setdelStatus}
                          />
                          {/* <div className="optional-text text-gray">
                            &nbsp;
                          </div> */}
                          <div className="footer-btn mob-hide">
                            <button className="contact-btn bg-brand">
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://dangleit.com/pages/contact-us"
                              >
                                Contact Us
                              </a>
                            </button>
                            <button
                              className={
                                emailedFor === 'Address' ||
                                order.folder_id == 399366 ||
                                success === 'success' ||
                                isCancelOrderDisabled(order.folder_id)
                                  ? 'contact-btn bg-gray'
                                  : order.folder_id == 399341 ||
                                    isEmailedFolder(order.folder_id)
                                  ? 'contact-btn bg-red'
                                  : 'contact-btn bg-gray'
                              }
                              disabled={isCancelOrderDisabled(order.folder_id)}
                              // onClick={() =>
                              //   setModalCancel(!modalCancel)
                              // }
                              onClick={() => setCancelSidebarOpen(true)}
                            >
                              Cancel Order
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sidebar-bottom-link mob-hide">
                  <Link href="https://dangleit.com/pages/privacy-policy" legacyBehavior>
                    <a>Store Policies</a>
                  </Link>
                  <span className="separator">|</span>
                  <Link href="https://dangleit.com/" legacyBehavior>
                    <a>Main Site</a>
                  </Link>
                  <span className="separator">|</span>
                  <Link href="https://dangleit.com/pages/privacy-policy" legacyBehavior>
                    <a>Privacy Policy</a>
                  </Link>
                </div>
              </div>
              <div className="col-lg-8">
                <div id="accordion" className="accordian-box">
                  <div className="card"
                    onClick={createCardClickHandler('collapseOne')}
                  >
                    <div
                      className="card-header"
                      id="headingOne"
                      tw="cursor-pointer"
                      onClick={() =>
                        collapseSection('collapseOne')
                      }
                    >
                      {/* <div className="banner-text">
                      Action Required
                    </div> */}
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          <span className="cal-logo">
                            {/* <Image
                              className="file-icon-img"
                              alt=""
                              src={FileIcon}
                            /> */}
                            <FontAwesomeIcon
                              icon={faFileLines}
                            />
                          </span>
                          <span className="tab-text">
                            Order Summary
                          </span>
                        </button>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      className="collapse "
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <div className="card-body-inner">
                          <OrderDetails />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      order?.source_id === "619971" || //testing
                      order?.folder_id === 399341 ||
                      order?.folder_id === 399370 ||
                      (isEmailedFolder(order?.folder_id) &&
                        emailedFor == 'Photo')
                        ? 'card '
                        : 'card disabled'
                    }
                    onClick={createCardClickHandler('collapseTwo', editItemsTooltipRef)}
                  >
                    <div
                      className="card-header"
                      id="headingTwo"
                      tw="cursor-pointer"
                      onClick={() =>
                        collapseSection('collapseTwo')
                      }
                    >
                      <div tw="flex flex-row items-center justify-between w-full">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                            onClick={toggleItem}
                          >
                            <span className="cal-logo">
                              <span className="disable-icon">
                                <FontAwesomeIcon icon={faList} />
                              </span>
                              <span className="enable-icon">
                                <FontAwesomeIcon icon={faList} />
                              </span>
                            </span>
                            <span className="tab-text">
                              {/* {itemValue} */}
                              Edit Items
                            </span>
                          </button>
                        </h5>
                      {isEmailedFolder(order?.folder_id) &&
                      emailedFor === "Photo"  ? (
                        <BannerWithTooltip text="Action Required" tooltip="" color="red-banner" section="editItems" triggerRef={editItemsTooltipRef} collapseId="collapseTwo"/>
                      ) : (
                        ''
                      )}


                      {
                      order?.folder_id === 399343 ||
                      order?.folder_id === 399345 ||
                      order?.folder_id === 399344 ||
                      order?.folder_id === 399346 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already with designers" color="colorGray" section="editItems" triggerRef={editItemsTooltipRef}/>
                      ) : (
                        ''
                      )}

                      {order?.folder_id === 399342 ||
                      order?.folder_id === 399347 ||
                      order?.folder_id === 399348 ||
                      order?.folder_id === 433467 ||
                      order?.folder_id === 433468 ||
                      order?.folder_id === 433469 ||
                      order?.folder_id === 125197 ||
                      order?.folder_id === 433470 ||
                      order?.folder_id === 433471 ||
                      order?.folder_id === 435748 ||
                      order?.folder_id === 435747 ||
                      order?.folder_id === 435746 ||
                      order?.folder_id === 435745 ||
                      order?.folder_id === 435744 ||
                      order?.folder_id === 435755 ||
                      order?.folder_id === 435743 ||
                      order?.folder_id === 435756 ||
                      (isEmailedFolder(order?.folder_id) &&
                        emailedFor == 'Address') ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already in production" color="colorGray" section="editItems" triggerRef={editItemsTooltipRef}/>
                      ) : (
                        ''
                      )}

                      {order?.folder_id === 435735 ||
                      order?.folder_id === 435733 ||
                      order?.folder_id === 435734
                      ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already shipped" color="colorGray" section="editItems" triggerRef={editItemsTooltipRef}/>
                      ) : (
                        ''
                      )}

                      {order?.folder_id === 435757 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already in quality review" color="colorGray" section="editItems" triggerRef={editItemsTooltipRef}/>
                      ) : (
                        ''
                      )}


                      {order?.folder_id === 399366 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already canceled" color="colorGray" section="editItems" triggerRef={editItemsTooltipRef}/>
                      ) : (
                        ''
                      )}
                      {order?.folder_id === 437224 ||
                      order?.folder_id === 435737  ? (
                        <BannerWithTooltip text="Unavailable" tooltip="" color="colorGray" section="editItems" triggerRef={editItemsTooltipRef}/>
                      ) : null}

                      {/* {delStatus?.status == 'delivered' ? (
                        <div className="banner-text">
                          Edit Window Closed (already delivered)
                        </div>
                      ) : (
                        ''
                      )} */}

                      </div>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <div className="card-body-inner">
                          <UpdateItems
                            state={state}
                            setStorageState={setStorageState}
                            referenceSection="update_items"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*  review proof — hidden on TikTok storefront host */}
                  {!isTiktok && (
                  <div
                    className={
                      order?.source_id === "619971" || //testing
                      order?.folder_id === 399346 
                        ? 'card'
                        : 'card disabled'
                    }
                    onClick={createCardClickHandler('collapseReviewProofs', reviewProofsTooltipRef)}
                  >
                    <div
                      className="card-header"
                      id="headingReviewProofs"
                      tw="cursor-pointer"
                      onClick={() => collapseSection('collapseReviewProofs')}
                    >
                      <div tw="flex flex-row items-center justify-between w-full">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseReviewProofs"
                            aria-expanded="false"
                            aria-controls="collapseReviewProofs"
                          >
                            <span className="cal-logo">
                              <span className="disable-icon">
                                <FontAwesomeIcon icon={faEye} />
                              </span>
                              <span className="enable-icon">
                                <FontAwesomeIcon icon={faEye} />
                              </span>
                            </span>
                            <span className="tab-text">
                              Review Proofs
                            </span>
                          </button>
                        </h5>
                      {order?.folder_id === 399346 ? (
                        <BannerWithTooltip text="Action Required" tooltip="" color="red-banner" section="reviewProofs" triggerRef={reviewProofsTooltipRef} collapseId="collapseReviewProofs"/>
                      ) : null}
                      {order?.folder_id === 399370 ||
                      order?.folder_id === 399341 ||
                      order?.folder_id === 399345 ||
                      order?.folder_id === 399344 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Proofs not yet created" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}

                    {order?.folder_id === 399343 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Revisions in progress" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}


                      {isEmailedFolder(order?.folder_id) ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already with designers" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}

                      {order?.folder_id === 399342 ||
                      order?.folder_id === 399347 ||
                      order?.folder_id === 399348 ||
                      order?.folder_id === 433467 ||
                      order?.folder_id === 433468 ||
                      order?.folder_id === 433469 ||
                      order?.folder_id === 125197 ||
                      order?.folder_id === 433470 ||
                      order?.folder_id === 433471 ||
                      order?.folder_id === 435748 ||
                      order?.folder_id === 435747 ||
                      order?.folder_id === 435746 ||
                      order?.folder_id === 435745 ||
                      order?.folder_id === 435744 ||
                      order?.folder_id === 435755 ||
                      order?.folder_id === 435743 ||
                      order?.folder_id === 435756 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already in production" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}

                      {order?.folder_id === 435757 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already in quality review" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}

                      {order?.folder_id === 435733  ||
                      order?.folder_id === 435734 ||
                      order?.folder_id === 435735? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already shipped" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}
                      {order?.folder_id === 437224 ||
                      order?.folder_id === 435737  ? (
                        <BannerWithTooltip text="Unavailable" tooltip="" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}

                      {order?.folder_id === 399366 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already canceled" color="colorGray" section="reviewProofs" triggerRef={reviewProofsTooltipRef}/>
                      ) : null}

                      </div>
                    </div>
                    <div
                      id="collapseReviewProofs"
                      className={`collapse`}
                      aria-labelledby="headingReviewProofs"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                      <div className="card-body-inner">
                          <UpdateProof
                            state={state}
                            setStorageState={setStorageState}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  )}



                  {!isTiktok && (
                  <div
                    className={
                      order?.folder_id === 399341 ||
                      order?.folder_id === 399342 ||
                      order?.folder_id === 399343 ||
                      order?.folder_id === 399344 ||
                      order?.folder_id === 399345 ||
                      order?.folder_id === 399346
                        ? 'card'
                        : 'card disabled'
                    }
                    onClick={createCardClickHandler('collapseThree', editAddressTooltipRef)}
                  >
                    <div
                      className="card-header"
                      id="headingThree"
                      tw="cursor-pointer"
                      onClick={() =>
                        collapseSection('collapseThree')
                      }
                    >
                      <div tw="flex flex-row items-center justify-between w-full">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                            onClick={toggleAddress}
                          >
                            <span className="cal-logo">
                              <span className="disable-icon">
                                {/* <Image alt="" src={HomeDisIcon} /> */}

                                <FontAwesomeIcon
                                  icon={faHouseChimney}
                                />
                              </span>
                              <span className="enable-icon">
                                <FontAwesomeIcon
                                  icon={faHouseChimney}
                                />
                                {/* <Image alt="" src={HomeIcon} /> */}
                              </span>
                            </span>
                            <span className="tab-text">
                              {/* {addressValue} */}
                              Edit Address
                            </span>
                          </button>
                        </h5>
                      {emailedFor == 'Address' ? (
                        <BannerWithTooltip text="Action Required" tooltip="" color="red-banner" section="editAddress" triggerRef={editAddressTooltipRef} collapseId="collapseThree"/>
                      ) : order.folder_id ==
                        '435734' ? null : null}
                      {(order?.folder_id === 399341 ||
                      order?.folder_id === 399342 ||
                      order?.folder_id === 399343 ||
                      order?.folder_id === 399344 ||
                      order?.folder_id === 399345 ||
                      order?.folder_id === 399346) ? (
                        ''
                      ) : (
                        <BannerWithTooltip text="Unavailable" tooltip="Already in production" color="colorGray" section="editAddress" triggerRef={editAddressTooltipRef}/>
                      )}

                      {order?.folder_id === 435757 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already in quality review" color="colorGray" section="editAddress" triggerRef={editAddressTooltipRef}/>
                      ) : (
                        ''
                      )}


                      {order?.folder_id === 435733  ||
                      order?.folder_id === 435734 ||
                      order?.folder_id === 435735? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already shipped" color="colorGray" section="editAddress" triggerRef={editAddressTooltipRef}/>
                      ) : (
                        ''
                      )}
{/* 
                      {delStatus?.status == 'delivered' ? (
                        <div className="banner-text">
                          Edit Window Closed (already delivered)
                        </div>
                      ) : (
                        ''
                      )} */}
                      {order?.folder_id === 437224 ||
                      order?.folder_id === 435737  ? (
                        <BannerWithTooltip text="Unavailable" tooltip="" color="colorGray" section="editAddress" triggerRef={editAddressTooltipRef}/>
                      ) : null}

                      {order?.folder_id === 399366 ? (
                        <BannerWithTooltip text="Unavailable" tooltip="Already canceled" color="colorGray" section="editAddress" triggerRef={editAddressTooltipRef}/>
                      ) : (
                        ''
                      )}

                      </div>
                    </div>
                    <div
                      id="collapseThree"
                      className="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <div className="card-body-inner">
                          <UpdateAddress
                            state={state}
                            setStorageState={setStorageState}
                          />
                        </div>
                      </div>
                    </div>
                  </div>)}
                  <div
                    className={
                      // order.folder_id == '435734' ||
                      // order.folder_id == '435735' ||
                      // order.folder_id == '399369' ||
                      // order.folder_id == '435736' ||
                      // order.folder_id == '435738' ||
                      // order.folder_id == '435737' ||
                      // order.folder_id == '437224' ||
                      // order.folder_id == '399370' ||
                      // order.folder_id == '399341' ||
                      // order.folder_id == '399342' ||
                      // order.folder_id == '399343' ||
                      // order.folder_id == '399344' ||
                      // order.folder_id == '399345' ||
                      // order.folder_id == '399346' ||
                      // order.folder_id == '399347' ||
                      // order.folder_id == '399348' ||
                      // order.folder_id == '433467' ||
                      // order.folder_id == '433468' ||
                      // order.folder_id == '433469' ||
                      // order.folder_id == '433470' ||
                      // order.folder_id == '433471' ||
                      // order.folder_id == '435743' ||
                      // order.folder_id == '435744' ||
                      // order.folder_id == '435745' ||
                      // order.folder_id == '435746' ||
                      // order.folder_id == '435747' ||
                      // order.folder_id == '435748' ||
                      // order.folder_id == '435755' ||
                      // order.folder_id == '435756' ||
                      // order.folder_id == '435757' ||
                      // order.folder_id == '435733'
                      order?.source_id === "619971" //testing
                        ? 'card' :
                      refundStatus // Refund request already Approved/Pending
                        ? 'card disabled' // Disable requests in this case
                      : isRequestProcessed
                        ? 'card disabled'
                      : isLostInTransit
                        ? 'card ' // Enable request if order is lost in transit and no pending/approved request
                      : order.order_total === 0 || // Order total is $0 (No refund/replacement needed)
                        order.folder_id === 435757 || // Order is in FedEx shipped folder
                        order.folder_id === 435734 || // New Requests folder
                        order.folder_id === 435735 || // Closed Requests folder
                        order_shipments?.length === 0 // Not yet shipped
                        ? 'card disabled' // Disable request in these cases
                      : (delStatus?.status !== 'delivered' && diffDaysForTracking > 5) || // Not delivered & tracking updated more than 5 days ago
                        (delStatus?.status === 'delivered' && diffDaysForDelivery <= 7) || // Delivered but within 7-day refund window
                        new Date(extended).getTime() > new Date().getTime() // Request extension period is still active
                        ? 'card ' // Enable request in these cases
                      : 'card disabled' // Default case - Disable request
                    
                    }
                    onClick={createCardClickHandler('collapseFour', replaceReturnTooltipRef)}
                  >
                    <div
                      className="card-header"
                      id="headingFour"
                      tw="cursor-pointer"
                      onClick={() =>
                        collapseSection('collapseFour')
                      }
                    >
                      <div tw="flex flex-row items-center justify-between w-full">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link"
                            data-toggle="collapse"
                            data-target="#collapseFour"
                            aria-expanded="true"
                            aria-controls="collapseFour"
                          >
                            <span className="cal-logo">
                              <span className="">
                                <span className="disable-icon">
                                  <FontAwesomeIcon
                                    icon={faRightLeft}
                                  />
                                </span>
                                <span className="enable-icon">
                                  <FontAwesomeIcon
                                    icon={faRightLeft}
                                  />
                                </span>
                              </span>
                            </span>
                            <span className="tab-text">
                              Replace/Return
                            </span>
                          </button>
                        </h5>
                      {/* {order_shipments?.length === 0 && (
                        <div className="banner-text colorGray">
                          Request Window Closed (not shipped)
                        </div>
                      )} */}

                      {/* {refundResponse && (
                        <div className="banner-text colorGreen">
                          Request Approved (20% refund issued)
                        </div>
                      )} */}
                      {/* 
                      {refundStatus && (
                        <div className="banner-text colorYellow">
                          Request Pending (can take up to 72
                          hours)
                        </div>
                      )}

                      {order.folder_id === 435734 && (
                        <div className="banner-text colorYellow">
                          Request Pending (can take up to 72
                          hours)
                        </div>
                      )} */}

                      {/* {order.folder_id === 435735 && (
                        <div className="banner-text colorGreen">
                          Request Approved (replacement order #{' '}
                          {order.source_id} ) */}
                      {/* {console.log(
                            order.source_id,
                            'ordersource_id',
                          )} */}
                      {/* </div>
                      )} */}

                      {/* {diffDaysForShipping < 10 &&
                        delStatus?.status !== 'delivered' && (
                          <div className="banner-text colorGray">
                            Request Window Closed (
                            {diffDaysForShipping} days ago)
                          </div>
                        )}

                      {diffDaysForDelivery > 7 && (
                        <div className="banner-text colorGray">
                          Request Window Closed (delivered 7+
                          days ago)
                        </div>
                      )}

                      {diffDaysForDelivery > 10 && (
                        <div className="banner-text colorGray">
                          Request Window Closed (delivered 7+
                          days ago)
                        </div>
                      )}

                      {extended && ''}

                      {fullyRefundResponse > 0 && (
                        <div className="banner-text colorGreen">
                          Request Approved (100% refund issued)
                        </div>
                      )} */}
                      {
                        // match ? (
                        //   <div className="banner-text colorGreen">
                        //     Request Approved (see email for
                        //     replacement order details)
                        //   </div>
                        // ) :
                        // isLostInTransit ? 
                        // <></> :
                        // fullyRefundResponse > 0 ? (
                        //   <div className="banner-text colorGreen">
                        //     Request Approved ($
                        //     {parseFloat(
                        //       fullyRefundResponse,
                        //     ).toFixed(2)}{' '}
                        //     refund issued)
                        //   </div>
                        // ) : refundResponse > 0 ? (
                        //   <div className="banner-text colorGreen">
                        //     Request Approved ($
                        //     {parseFloat(refundResponse).toFixed(
                        //       2,
                        //     )}{' '}
                        //     refund issued)
                        //   </div>
                        // ) : order.folder_id === 435735 ? (
                        //   <div className="banner-text colorGreen">
                        //     Request Approved (see email for
                        //     replacement order details)
                        //   </div>
                        // ) : // isReturnable > 0
                        // order.folder_id === 435734 ||
                        //   refundStatus ? (
                        //   // Temporary Change
                        //   <div className="banner-text colorYellow">
                        //     Request Pending
                        //   </div>
                        //   //<div className="banner-text colorYellow">
                        //   //  Request Pending (can take up to 72
                        //   //  hours)
                        //   //</div>                         
                        // ) : order.folder_id === 435757 ? (
                        //   <div className="banner-text colorGray">
                        //     Request Window Closed (not yet shipped)
                        //   </div>
                        // ) : new Date(extended).getTime() >
                        //   new Date().getTime() ? (
                        //   ''
                        // ) : diffDaysForTracking <= 11 &&
                        // delStatus?.status != 'delivered' ? (
                        // <div className="banner-text colorGray">
                        //   Request Window Closed (tracking
                        //   updated {'<'}11 days ago)
                        // </div>
                        // // Temporary
                        // //  : diffDaysForTracking <= 5 &&
                        // //   delStatus?.status != 'delivered' ? (
                        // //   <div className="banner-text colorGray">
                        // //     Request Window Closed (tracking
                        // //     updated {'<'}5 days ago)
                        // //   </div>
                        // ) : diffDaysForDelivery > 7 &&
                        //   delStatus?.status == 'delivered' ? (
                        //   <div className="banner-text colorGray">
                        //     Request Window Closed (delivered{' '}
                        //     {'>'}7 days ago)
                        //   </div>
                        // ) : // : diffDaysForShipping >= 7 &&
                        // //   delStatus?.status !== 'delivered' ? (
                        // //   <div className="banner-text colorGray">
                        // //     {/* Request Window Closed ( shipped{' '}
                        // //     {diffDaysForShipping} days ago) */}
                        // //     Request Window Closed ( delivered {'>'}7 days ago)
                        // //   </div>
                        // // )
                        // order_shipments?.length === 0 ? (
                        //   <div className="banner-text colorGray">
                        //     Request Window Closed (not yet
                        //     shipped)
                        //   </div>
                        // ) : (
                        //   ''
                        // )
                        requestBanner && (
                          <BannerWithTooltip
                            text={requestBanner.text}
                            tooltip={requestBanner.tooltip}
                            color={requestBanner.color}
                            section="replaceReturn"
                            triggerRef={requestBanner.reference}
                            collapseId={requestBanner.collapseId}
                          />
                        )
                      }

                      </div>
                    </div>

                    <div
                      id="collapseFour"
                      className={` ${'collapse'} 
                      ${refundStatus && 'collapse'} `}
                      aria-labelledby="headingFour"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <div className="card-body-inner">
                          <Refund
                            delStatus={delStatus}
                            setrefundStatus={setrefundStatus}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card mb-md-30 mb-0 mb-sm-15"
                    onClick={createCardClickHandler('collapseFive')}
                  >
                    <div
                      className="card-header"
                      id="headingFive"
                      tw="cursor-pointer"
                      onClick={() =>
                        collapseSection('collapseFive')
                      }
                    >
                      {/* <div className="banner-text">
                      Action Required
                    </div> */}
                      <h5 className="mb-0">
                        <button
                          className="btn btn-link"
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="true"
                          aria-controls="collapseFive"
                          onClick={() => setShQuantity(true)}
                        >
                          <span className="cal-logo">
                            <span className="">
                              <span className="disable-icon">
                                <FontAwesomeIcon
                                  icon={faCartShopping}
                                />
                              </span>
                              <span className="enable-icon">
                                <FontAwesomeIcon
                                  icon={faCartShopping}
                                />
                                {/* <Image alt="" src={OrderIcon} /> */}
                              </span>
                            </span>
                          </span>
                          <span className="tab-text">
                            Reorder
                          </span>
                        </button>
                      </h5>
                    </div>

                    <div
                      id="collapseFive"
                      className="collapse"
                      aria-labelledby="headingFive"
                      data-parent="#accordion"
                    >
                      <div className="card-body">
                        <div className="card-body-inner">
                          <Reorder shQuantity={shQuantity} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <main>{children}</main> */}
              </div>
              <div className="col-lg-12">
                <div className="footer-btn mob-show desktop-hide wd-100">
                  <button className="contact-btn bg-brand">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://dangleit.com/pages/contact-us"
                    >
                      Contact Us
                    </a>
                  </button>
                  <button
                    className={
                      order.folder_id == 399366 ||
                      success === 'success' ||
                      isCancelOrderDisabled(order.folder_id)
                        ? 'contact-btn bg-gray'
                        : order.folder_id == 399341 ||
                          isEmailedFolder(order.folder_id) ||
                          emailedFor === 'Photo'
                        ? 'contact-btn bg-red'
                        : 'contact-btn bg-gray'
                    }
                    disabled={isCancelOrderDisabled(order.folder_id)}
                    onClick={() => setCancelSidebarOpen(true)} // Open Sidebar
                    // onClick={() => setModalCancel(!modalCancel)}
                  >
                    Cancel Order
                  </button>
                </div>
              </div>
              <div className="col-lg-12 mob-show wd-100">
                <div className="sidebar-bottom-link">
                  <Link href="https://dangleit.com/pages/contact-us" legacyBehavior>
                    <a>Contact Us</a>
                  </Link>
                  <span className="separator">|</span>
                  <Link href="https://dangleit.com/" legacyBehavior>
                    <a>Main Site</a>
                  </Link>
                  <span className="separator">|</span>
                  <Link href="https://dangleit.com/pages/privacy-policy" legacyBehavior>
                    <a>Store Policies</a>
                  </Link>
                  <span className="separator">|</span>
                  <button onClick={() => logoutUser()} style={{fontWeight: "400", textDecoration: "underline"}}>
                    Log Out
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div tw="min-h-screen flex  bg-gray-50">
        {query?.id && (
          <SidebarNavMobile
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />
        )}

        <SidebarNavDesktop />
        <div tw="flex flex-col w-0 flex-1 overflow-y-auto">
          {query?.id && (
            <div tw="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 flex items-center ">
              <button
                tw="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                onClick={() => setSidebarOpen(true)}
              >
                <span tw="sr-only">Open sidebar</span>
                <MenuIcon
                  tw="h-8 w-8 text-brand"
                  aria-hidden="true"
                />
              </button>
              <span tw="mx-auto pr-12 pt-2">
                <Image
                  alt="Dangle It Logo"
                  width="85"
                  height="30"
                  tw="h-8 w-auto text-center inline-block"
                  src="/logo.png"
                  quality={100}
                />
              </span>
            </div>
          )}
          <main tw="flex-1 relative z-0 focus:outline-none">
            <div
              css={[
                tw`px-6 py-6 mx-auto max-w-7xl sm:px-10 md:px-20`,
                !query?.id && tw`flex h-full`,
              ]}
            >
              {children}
            </div>
          </main>
        </div>
      </div> */}
        {/* cancel order modal */}
        {/* <Modal
          toggle={() => setModalCancel(!modalCancel)}
          isOpen={modalCancel}
          className="popup-dialog edit-item-popup cancel-order-popup"
        >
          {' '}
          <div className="p-2">
            <div className="top-header-item">
              <div className="d-flex align-items-center">
                <span className="mr-4 d-flex cart-icon">
                  <FontAwesomeIcon icon={faTrashCan} />
                </span>
                <span className="heading">Cancel Order</span>
              </div>
              <span
                aria-hidden={true}
                onClick={() => {
                  setModalCancel(!modalCancel)
                }}
                className="cursor-pointer close-btn"
              >
                <span className="close-icon d-flex cart-icon">
                  <FontAwesomeIcon icon={faXmark} />
                </span>
              </span>
            </div>
          </div>
          <div className="modal-content-box ">
            <CancelOrder
              toggleShow={toggleShow}
              setSuccess={setSuccess}
            />
          </div>
        </Modal> */}
        <GenericSidebar
          title="Cancel Order"
          isOpen={cancelSidebarOpen}
          icon={<FontAwesomeIcon icon={faTrashCan} />}
          onClose={() => setCancelSidebarOpen(false)}
          footer={
            <div tw="text-center">
              <button
                tw="bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => setCancelSidebarOpen(false)}
              >
                Close
              </button>
            </div>
          }
        >
          <CancelOrder toggleShow={() => setCancelSidebarOpen(false)} setSuccess={setSuccess} />
        </GenericSidebar>

        <SessionTimeoutSidebar
          isOpen={sessionTimeoutSidebarOpen}
          onRefresh={() => {
            setSessionTimeoutSidebarOpen(false);
            resetTimeout();
            window.location.reload();
          }}
        />

      </div>
    )
  )
}

export const getLayout = page => <SiteLayout>{page}</SiteLayout>

export default SiteLayout
